import Button from "core/buttons/button/Button";
import InvalidMissionPage from "./InvalidMissionPage";
import Loader from "core/loader/LoaderV2";
import MissionBalancesheetContent from "components/balancesheet/content/MissionBalancesheetContent";
import SavedEvaluationPage from "./SavedEvaluationPage";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import {
  MISSION_STATUS,
  QUERY_STATUS,
  SAVE_MISSIONS_ACTIONS,
} from "constants/constants";
import { Typography } from "core/typography/Typography";
import {
  formatEvaluationMissionPayload,
  createError,
  flattenTree,
  validateField,
  getFieldValueById,
  transformErrors,
} from "utils/balancesheetHelper";
import { useEffect, useRef, useState } from "react";
import { useMissionBalancesheetContext } from "api/balance-sheet/mission/MissionBalancesheetProvider";
import { useParams } from "react-router-dom";

const MissionBalancesheetPage = () => {
  const { token, slug } = useParams();
  const {
    getMissionBalanceSheetWithSlugToken,
    missionBalancesheet,
    saveEvaluationMission,
    savedMission,
    setSavedMission,
    missionStatus,
  } = useMissionBalancesheetContext();
  const [localErrors, setLocalErrors] = useState({});
  const status = missionBalancesheet?.balancesheet?.status;
  const isCreated = missionStatus === MISSION_STATUS.PUBLISHED;
  const [isValidated, setIsValidated] = useState(false);
  const isFinishedOrPublished = status === MISSION_STATUS.CLIENT_FINISHED;

  const clearError = (id) => {
    setLocalErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[id];
      return newErrors;
    });
  };

  const serverErrors = transformErrors(savedMission?.errors);
  const errors = { ...serverErrors, ...localErrors };

  const dynamicTable = useRef([]);
  const [form, setForm] = useState({
    fields: [],
  });

  useEffect(() => {
    if (token && slug) getMissionBalanceSheetWithSlugToken({ token, slug });
  }, []);

  const getModules = () => {
    if (!missionBalancesheet?.balancesheet) return [];
    return _.drop(flattenTree(missionBalancesheet?.balancesheet), 1);
  };

  const validate = (e) => {
    e.preventDefault();
    setIsValidated(true);

    const modules = getModules();
    const nextErrors = {};
    modules.forEach((module) => {
      const lineIds = [1];
      (module?.fields || []).forEach((field) => {
        lineIds.forEach((lineId) => {
          const id = `${field?.field_id}_${lineId}`;
          const val = getFieldValueById(form?.fields, field?.field_id, lineId);
          const err = validateField(field, val, id);
          if (err) nextErrors[id] = err;
        });
      });
    });

    setLocalErrors(nextErrors);

    if (Object.keys(nextErrors).length > 0) {
      return;
    }

    const totalForm = _.chain(form.fields)
      .concat(dynamicTable.current)
      .map((elm) => ({
        id: elm?.id,
        fieldId: elm?.field_id, //we verify required field usconsoling field_id and not id
        value: elm.value,
      }))
      .value();
    const payload = formatEvaluationMissionPayload(
      totalForm,
      SAVE_MISSIONS_ACTIONS.PUBLISH,
      {
        processedBy: missionBalancesheet?.balancesheet?.person_id,
      }
    );

    saveEvaluationMission({
      id: missionBalancesheet?.balancesheet?.id,
      data: payload,
    });
  };

  useEffect(() => setSavedMission({}), []);

  return (
    <div className="balancsheet-section balancesheet-responsive-page">
      {missionStatus === QUERY_STATUS.LOADING && (
        <Loader key="load-mission" id="load-mission" />
      )}
      {missionStatus === QUERY_STATUS.ERROR && <InvalidMissionPage />}

      {isCreated ? (
        <SavedEvaluationPage
          titleId="evaluation_saved"
          messageId="evaluation_saved_message"
        />
      ) : isFinishedOrPublished ? (
        <SavedEvaluationPage
          titleId="evaluation_already_saved"
          messageId="evaluation_already_submitted_message"
        />
      ) : (
        (missionStatus === QUERY_STATUS.SUCCESS || !_.isEmpty(errors)) && (
          <>
            <Typography
              className="title-2 violet text-uppercase"
              type="h2"
              label={missionBalancesheet?.balancesheet?.template_title || ""}
            />
            <div className="separator-title"></div>

            <MissionBalancesheetContent
              data={missionBalancesheet}
              readOnly={false}
              form={form}
              setForm={setForm}
              dynamicTable={dynamicTable}
              errors={errors}
              isValidated={isValidated}
              clearError={clearError}
            />
            <Button
              color="btn-medium gray-700"
              id="button-form-validation"
              type={"submit"}
              onClick={validate}
            >
              <FormattedMessage
                id="button_balancesheet_validation"
                defaultMessage="Sauvegarder et envoyer"
              />
            </Button>
          </>
        )
      )}
    </div>
  );
};

export default MissionBalancesheetPage;
